module.exports = __webpack_public_path__ + "media/images/emblems/Reisiswil-coat_of_arms-01043882f27ffd51d041f066c324733c.svg";